/**
 * @generated SignedSource<<26cd0e1ff0202724974b1f8b75bf9d23>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleLeftHandSideWidgetsContent$data = {
  readonly seriesContainer: {
    readonly series: ReadonlyArray<{
      readonly __typename: string;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"seriesWidgetContent" | "topPicksWidgetContent">;
  readonly " $fragmentType": "articleLeftHandSideWidgetsContent";
};
export type articleLeftHandSideWidgetsContent$key = {
  readonly " $data"?: articleLeftHandSideWidgetsContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleLeftHandSideWidgetsContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleLeftHandSideWidgetsContent",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "seriesWidgetContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "topPicksWidgetContent"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Article",
      "kind": "LinkedField",
      "name": "seriesContainer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "series",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "d1c168ec30cfbcc109d5c7d20d402515";

export default node;
